import React from "react";

import TopNav from "../components/TopNav";

import RouteSearch from "../components/RouteSearch";

const RoutePage = (props) => {

    return(
        <React.Fragment>
                <TopNav darkMode={props.darkmode}/>
                <div className="routes" >
                    <RouteSearch darkmode={props.darkmode} />
                </div>
        </React.Fragment>)
 
}
export default RoutePage;